import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip, Typography, Breadcrumbs } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import * as Styled from './styled';

type Props = {
  onBack: () => void;
  secondaryText: string;
  primaryText: string;
  title: string;
};

export const DetailBreadcrumbs: FC<Props> = ({
  onBack,
  secondaryText,
  primaryText,
  title,
}) => {
  const { t } = useTranslation();

  return (
    <Styled.Title>
      <Tooltip title={t('GetBack')}>
        <Styled.HeaderIconButton onClick={onBack}>
          <ArrowBack />
        </Styled.HeaderIconButton>
      </Tooltip>
      <div>
        <Breadcrumbs>
          <Styled.SecondaryText
            variant="body1"
            fontSize={16}
            color="text.secondary"
            onClick={onBack}
          >
            {secondaryText}
          </Styled.SecondaryText>
          <Typography variant="body1" fontSize={16} color="text.primary">
            {primaryText}
          </Typography>
        </Breadcrumbs>
        {title && (
          <Typography variant="h6" fontSize={20} color="text.primary">
            {title}
          </Typography>
        )}
      </div>
    </Styled.Title>
  );
};
